import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Paperclip, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API, Badge, Frist, fehler, feld, oeffnen } from "./shared";

const LEER = { audit: "", nummer: "", art: "Abweichung", text: "", verantwortlich: "", frist: "" };

const Feststellung = ({ f, laden }) => {
  const [antwort, setAntwort] = useState(f.antwort || "");
  const speichern = () => axios.put(`${API}/feststellungen/${f.id}`, { antwort }).then(() => { toast.success("Stellungnahme gespeichert"); laden(); }).catch(fehler);
  const hoch = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    axios.post(`${API}/feststellungen/${f.id}/belege`, fd).then(() => { toast.success("Beleg hochgeladen"); laden(); }).catch(fehler);
  };
  return (
    <div className="p-3 text-sm space-y-2" data-testid={`feststellung-${f.nummer}`}>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="font-semibold">Nr. {f.nummer}</span><Badge ton={f.art === "Abweichung" ? "rot" : "gelb"}>{f.art}</Badge>
        <span className="text-[#78716c]">{f.verantwortlich}</span><Frist frist={f.frist} erledigt={f.status === "beantwortet"} />
        <span className="ml-auto"><Badge ton={f.status === "beantwortet" ? "gruen" : "grau"} testid={`feststellung-status-${f.nummer}`}>{f.status}</Badge></span>
      </div>
      <p className="text-[#5C534D]">{f.text}</p>
      <textarea className={feld} rows={2} placeholder="Stellungnahme / umgesetzte Maßnahme" value={antwort} onChange={(e) => setAntwort(e.target.value)} data-testid={`feststellung-antwort-${f.nummer}`} />
      <div className="flex flex-wrap items-center gap-2">
        <Button size="sm" variant="outline" onClick={speichern} data-testid={`feststellung-speichern-${f.nummer}`}>Speichern</Button>
        <label className="text-xs underline cursor-pointer inline-flex items-center gap-1"><Paperclip size={12} />Beleg hochladen<input type="file" className="hidden" onChange={hoch} data-testid={`feststellung-beleg-${f.nummer}`} /></label>
        {f.belege.map((b) => <button key={b.id} className="text-xs text-[#9A3B2E] underline" onClick={() => oeffnen(`/feststellungen/${f.id}/belege/${b.id}`, b.name)}>{b.name}</button>)}
      </div>
    </div>
  );
};

export const QMFeststellungen = () => {
  const [liste, setListe] = useState([]);
  const [neu, setNeu] = useState(LEER);
  const laden = useCallback(() => axios.get(`${API}/feststellungen`).then((r) => setListe(r.data)).catch(fehler), []);
  useEffect(() => { laden(); }, [laden]);
  const s = (k) => (e) => setNeu({ ...neu, [k]: e.target.value });
  const anlegen = (e) => { e.preventDefault(); axios.post(`${API}/feststellungen`, neu).then(() => { setNeu({ ...LEER, audit: neu.audit }); laden(); }).catch(fehler); };
  const audits = [...new Set(liste.map((f) => f.audit))];
  return (
    <div className="space-y-4" data-testid="qm-feststellungen">
      <form onSubmit={anlegen} className="grid grid-cols-2 md:grid-cols-6 gap-2 bg-white rounded-xl p-4 border border-[#F0E6DC]">
        <input className={`${feld} col-span-2`} list="audits" placeholder="Audit (z. B. Überwachungsaudit 2026) *" required value={neu.audit} onChange={s("audit")} data-testid="feststellung-audit" />
        <datalist id="audits">{audits.map((a) => <option key={a} value={a} />)}</datalist>
        <input className={feld} placeholder="Nr. *" required value={neu.nummer} onChange={s("nummer")} data-testid="feststellung-nummer" />
        <select className={feld} value={neu.art} onChange={s("art")} data-testid="feststellung-art">{["Abweichung", "Hinweis", "Empfehlung"].map((x) => <option key={x}>{x}</option>)}</select>
        <input className={feld} placeholder="Verantwortlich *" required value={neu.verantwortlich} onChange={s("verantwortlich")} data-testid="feststellung-verantwortlich" />
        <input className={feld} type="date" required value={neu.frist} onChange={s("frist")} data-testid="feststellung-frist" />
        <textarea className={`${feld} col-span-2 md:col-span-5`} rows={2} placeholder="Feststellung laut Auditbericht *" required value={neu.text} onChange={s("text")} data-testid="feststellung-text" />
        <Button type="submit" size="sm" className="bg-[#9A3B2E] hover:bg-[#7F2F25]" data-testid="feststellung-anlegen">Erfassen</Button>
      </form>
      {audits.map((a) => (
        <div key={a} className="bg-white rounded-xl border border-[#F0E6DC]">
          <div className="flex items-center justify-between p-3 border-b border-[#F6E3DA]">
            <h3 className="font-semibold">{a}</h3>
            <Button size="sm" variant="outline" onClick={() => oeffnen(`/feststellungen/antwortpaket?audit=${encodeURIComponent(a)}`, `Antwortpaket_${a}.zip`)} data-testid={`antwortpaket-${a}`}><Download size={14} className="mr-1" />Antwortpaket (ZIP)</Button>
          </div>
          <div className="divide-y divide-[#F6E3DA]">{liste.filter((f) => f.audit === a).map((f) => <Feststellung key={f.id} f={f} laden={laden} />)}</div>
        </div>
      ))}
    </div>
  );
};
